(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function() {
  const primaryNav = document.querySelector('.header__primary-nav');
  const secondaryNav = document.querySelector('.header__secondary-nav');

  const LIGHT_COLOR = '#F1F0ED';
  const DARK_COLOR  = '#101214';

  function getLuminance(r, g, b) {
    const toLinear = c => {
      c /= 255;
      return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    };
    return 0.2126 * toLinear(r) + 0.7152 * toLinear(g) + 0.0722 * toLinear(b);
  }

  function parseRgb(rgbStr) {
    const match = rgbStr.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
    if (!match) return null;
    return { r: +match[1], g: +match[2], b: +match[3] };
  }

  function getBgColor() {
    const header = document.querySelector('.header');
    if (!header) return null;
    const headerBottom = header.getBoundingClientRect().bottom;

    // data-bg-tone 속성으로 명시적 지정 확인
    const toneSections = document.querySelectorAll('[data-bg-tone]');
    for (const section of toneSections) {
      const rect = section.getBoundingClientRect();
      if (rect.top <= headerBottom && rect.bottom >= 0) {
        const tone = section.getAttribute('data-bg-tone');
        if (tone === 'dark') return 'rgb(16, 18, 20)';
        if (tone === 'light') return 'rgb(241, 240, 237)';
      }
    }

    // 일반 배경색 감지
    const headerRect = header.getBoundingClientRect();
    const sampleX = window.innerWidth / 2;
    const sampleY = headerRect.bottom + 10;

    header.style.pointerEvents = 'none';
    const el = document.elementFromPoint(sampleX, sampleY);
    header.style.pointerEvents = '';

    if (!el) return null;

    let target = el;
    while (target && target !== document.body) {
      const bg = getComputedStyle(target).backgroundColor;
      if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') {
        return bg;
      }
      target = target.parentElement;
    }
    return getComputedStyle(document.body).backgroundColor;
  }

  function updateHeaderColor() {
    const bgStr = getBgColor();
    if (!bgStr) return;

    const rgb = parseRgb(bgStr);
    if (!rgb) return;

    const lum = getLuminance(rgb.r, rgb.g, rgb.b);
    const isDark = lum < 0.5;
    const color = isDark ? LIGHT_COLOR : DARK_COLOR;

    if (primaryNav) primaryNav.style.setProperty('--header-color', color);
    if (secondaryNav) secondaryNav.style.setProperty('--header-color', color);

    const logo = document.querySelector('.header__logo-image:not(.header__logo-image--transparent)');
    if (logo) {
      logo.style.filter = isDark
        ? 'brightness(0) saturate(100%) invert(97%) sepia(4%) saturate(271%) hue-rotate(314deg) brightness(101%) contrast(93%)'
        : 'none';
    }
  }

  window.addEventListener('scroll', updateHeaderColor, { passive: true });
  document.addEventListener('DOMContentLoaded', updateHeaderColor);
  setTimeout(updateHeaderColor, 200);
  updateHeaderColor();
})();

  } catch(e) { console.error(e); }
})();
})();
